import React from 'react'
import { connect } from 'react-redux'
import Titulo from '../comum/Titulo';
import Autorizacao from '../../security/Autorizacao';
import {
    getAdminEmpresa,
    getFiscalEmbarque,
    getOperadorEmpresa,
    getVendedorAgencia,
    getVendedorEmpresa,
    PERFIL_ADMIN,
} from '../../security/securityContext';
import buscarEncomendasEmpresa from '../../actions/encomenda/buscarEncomendasEmpresa';
import determinarPaginaAtualEncomenda from '../../actions/encomenda/determinarPaginaAtualEncomenda';
import limparFiltroEncomenda from '../../actions/encomenda/limparFiltroEncomenda';
import { alterouEmpresa } from '../../actions/empresa/alterarEmpresaSelecionada';
import { alterouPagina, FILTRO_NUMERO_PEDIDO, FILTRO_CPF } from '../../util/filtros';
import { gerarHashForString } from '../../util/stringUtil';
import CabecalhoRodapeTabela from '../comum/CabecalhoRodapeTabela';
import PaginacaoEncomenda from './PaginacaoEncomenda';
import BotoesPaginacaoEncomenda from './BotoesPaginacaoEncomenda';
import LinhaEncomendaEntrega from './LinhaEncomendaEntrega';
import ModalInformarEntregaEncomenda from './ModalInformarEntregaEncomenda';

// dois campos de busca independentes, como no mockup: número do pedido/OS
// OU CPF do remetente/destinatário (a busca por CPF já cobre os dois lados,
// ver EncomendaSpecifications.cpfRemetenteOuDestinatarioEquals no backend)
function montarFiltroBusca(numeroPedido, cpf) {
    const filtros = [];
    if (numeroPedido) {
        filtros.push({ ...FILTRO_NUMERO_PEDIDO, valor: numeroPedido.replace(/\D/g, '') });
    }
    if (cpf) {
        filtros.push({ ...FILTRO_CPF, valor: cpf.replace(/\D/g, '') });
    }
    return filtros;
}

export const CabecalhoTabela = () => (
    <div className="vx-gp-table-header vx-gp-table-header--registrar-entrega">
        <div></div>
        <div>Nº Pedido</div>
        <div>Vendedor</div>
        <div>Descrição</div>
        <div>Remetente</div>
        <div>Data Emissão</div>
        <div>Data Entrega</div>
        <div>Status de Entrega</div>
        <div>Valor</div>
        <div>Ações</div>
    </div>
);

export class PainelRegistrarEntregaEncomenda extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            numeroPedido: '',
            cpf: '',
            imagensInformarEntrega: [],
        };
    }

    UNSAFE_componentWillMount() {
        this.props.determinarPaginaAtualEncomenda(1);
        this.props.limparFiltroEncomenda();
    }

    componentDidMount() {
        if (this.props.empresaSelecionada.id) {
            this.buscar();
        }
    }

    componentDidUpdate(prevProps) {
        if (alterouEmpresa(this.props, prevProps) || alterouPagina(this.props, prevProps)) {
            this.buscar();
        }
    }

    buscar = () => {
        this.props.buscarEncomendasEmpresa(
            this.props.empresaSelecionada.id,
            this.props.paginaAtual,
            this.props.registrosPorPagina,
            montarFiltroBusca(this.state.numeroPedido, this.state.cpf)
        );
    }

    acionarBusca = () => {
        this.props.determinarPaginaAtualEncomenda(1);
        this.buscar();
    }

    preencherModalInformarEntregaEncomenda(imagensInformarEntrega) {
        if (imagensInformarEntrega && imagensInformarEntrega.length > 0) {
            this.setState({
                imagensInformarEntrega: imagensInformarEntrega.map(it => ({
                    hash: gerarHashForString(`${it.nome}`),
                    ...it
                }))
            });
        } else {
            this.setState({ imagensInformarEntrega: [] });
        }
    }

    removerImagemInformarEntrega(arquivo) {
        this.setState({ imagensInformarEntrega: this.state.imagensInformarEntrega.filter(it => it.hash !== arquivo.hash) });
    }

    adicionarImagensInformarEntrega(arquivos) {
        this.setState({ imagensInformarEntrega: arquivos });
    }

    limparImagensInformarEntrega() {
        this.setState({ imagensInformarEntrega: [] });
    }

    exibirEncomendas() {
        if (this.props.encomendas && this.props.encomendas.length) {
            return (
                <div className="vx-list-container" style={{ marginTop: 16 }}>
                    <CabecalhoRodapeTabela OpcoesPaginacao={PaginacaoEncomenda}
                        BotoesPaginacao={BotoesPaginacaoEncomenda}
                        encomendas={this.props.encomendas}
                        empresaSelecionada={this.props.empresaSelecionada}>
                        <CabecalhoTabela />
                        {this.props.encomendas.map((encomenda, index) => (
                            <LinhaEncomendaEntrega key={index} encomenda={encomenda}
                                preencherModalInformarEntregaEncomenda={this.preencherModalInformarEntregaEncomenda.bind(this)} />
                        ))}
                    </CabecalhoRodapeTabela>
                </div>
            )
        }
        return (
            <div className="vx-gp-empty">
                <span className="material-icons vx-gp-empty-icon">inventory</span>
                <p className="vx-gp-empty-text">Nenhuma encomenda encontrada</p>
            </div>
        );
    }

    render() {
        return (
            <Autorizacao perfisPermitidos={[
                PERFIL_ADMIN,
                getAdminEmpresa(this.props.empresaSelecionada.id),
                getOperadorEmpresa(this.props.empresaSelecionada.id),
                getVendedorEmpresa(this.props.empresaSelecionada.id),
                getVendedorAgencia(this.props.empresaSelecionada.id),
                getFiscalEmbarque(this.props.empresaSelecionada.id)]}
                empresaSelecionada={this.props.empresaSelecionada}>
                <div>
                    <div className="row internas">
                        <Titulo texto="Registrar entrega de encomenda" urlRetorno="/menu-encomendas" />
                        <div className="col-12" style={{ marginBottom: 16 }}>
                            <div className="vx-busca-encomenda-header">
                                <span className="material-icons" style={{ fontSize: 16, verticalAlign: 'middle' }}>search</span>
                                &nbsp;Buscar encomenda
                            </div>
                            <div className="vx-busca-encomenda-body">
                                <div className="form-group" style={{ flex: 1, marginBottom: 0 }}>
                                    <label>Número do pedido/OS</label>
                                    <input type="text" className="form-control"
                                        value={this.state.numeroPedido}
                                        onChange={e => this.setState({ numeroPedido: e.target.value })}
                                        onKeyDown={e => { if (e.key === 'Enter') this.acionarBusca(); }} />
                                </div>
                                <div className="form-group" style={{ flex: 1, marginBottom: 0 }}>
                                    <label>CPF remetente/destinatário</label>
                                    <input type="text" className="form-control"
                                        value={this.state.cpf}
                                        onChange={e => this.setState({ cpf: e.target.value })}
                                        onKeyDown={e => { if (e.key === 'Enter') this.acionarBusca(); }} />
                                </div>
                                <button type="button" className="btn btn-primary" style={{ height: 38, alignSelf: 'flex-end' }}
                                    onClick={this.acionarBusca}>
                                    <span className="material-icons" style={{ fontSize: 15, verticalAlign: 'middle' }}>search</span>
                                    &nbsp;Buscar
                                </button>
                            </div>
                        </div>
                        <div className="col-12">
                            {this.exibirEncomendas()}
                        </div>
                    </div>
                    <ModalInformarEntregaEncomenda buscarEncomendas={this.buscar}
                        exibirNotificarEntrega={false}
                        exibirFinalizarEntrega={true}
                        arquivos={this.state.imagensInformarEntrega}
                        removerImagem={this.removerImagemInformarEntrega.bind(this)}
                        adicionarImagens={this.adicionarImagensInformarEntrega.bind(this)}
                        limparImagens={this.limparImagensInformarEntrega.bind(this)} />
                </div>
            </Autorizacao>
        )
    }
}

export function mapStateToProps(state) {
    return {
        encomendas: state.encomendas.encomendas,
        empresaSelecionada: state.empresaSelecionada,
        paginaAtual: state.paginaAtualEncomenda,
        registrosPorPagina: state.registrosPorPaginaEncomenda,
    }
}

export default connect(mapStateToProps, {
    buscarEncomendasEmpresa,
    determinarPaginaAtualEncomenda,
    limparFiltroEncomenda,
})(PainelRegistrarEntregaEncomenda);
